// extracted by mini-css-extract-plugin
export default {"page__404__parent":"_404_page__404__parent__4kAAG","page_404_container":"_404_page_404_container__CClZz","text__container":"_404_text__container__3ZoRx"};